
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAAB1UExURQAAADh7/zl5/zh6/zl6/zh6/zh3/0Bw/zl6/zd5 /zl5/zh3/zl7/zd5/zl7/0B//zh5/zl5/zh6/1GL/5u8/1GK/+bv/////+bu//L3/83d/9rm/12T /2qb/0WC/7TO/3aj/2mb/6jF/4+0/4Ks/8DV/wAAADqPS/AAAAASdFJOUwBAj9/PnyAQkI/PQM/P jxDfP5LbpTEAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5wwEAzki VKWJywAAALFJREFUKM99kusOwiAMRisbuzh1WsANd5/6/q/opoyoaTm/SA8NpP0AFnYiwh9imcCH NEOCPH27GEn2q82QIQdIkKUAyUsBB3dS2mNcKYLt2rXy1FvNy+oLUlrLylvTdqzsEYe6x5GUTTtU VuuGeTPwIY3IvzmpDmtjZlr2Cu39QcvnNM2BIQQnxEpy8Fu0iJUd4cQvW0LByyWebKtY0leGogkl 2StSl/lE/nWfxWWtvwAepTckfVGdUwAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMy0xMi0wNFQwMjoz MjoxMCswMDowMMHnuWsAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjMtMTItMDRUMDI6MzI6MTErMDA6 MDAWzQpjAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTEyLTA0VDAzOjU3OjM0KzAwOjAwgs/b 5AAAAABJRU5ErkJggg=="}})])
          )
        }
      }
    